module.exports = __webpack_public_path__ + "media/images/sec2bg-32890e60344342a119fdf28467adfae3.svg";